import React from 'react';
import * as Styled from './BackgroundOverlay.styled';

const BackgroundOverlay: React.FC = ({ children }) => {
    return (
        <Styled.BackgroundOverlayWrapper>
            {children}
        </Styled.BackgroundOverlayWrapper>
    );
};

BackgroundOverlay.displayName = 'Section.BackgroundOverlay';

export default BackgroundOverlay;
